import script from "./VUploadVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./VUploadVideo.vue?vue&type=script&lang=ts&setup=true"

import "./VUploadVideo.vue?vue&type=style&index=0&id=61132947&lang=css&scoped=true"
import "./VUploadVideo.vue?vue&type=style&index=1&id=61132947&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61132947"]])

export default __exports__